import { render, staticRenderFns } from "./Languagedropdown.vue?vue&type=template&id=d65803e2&scoped=true&"
import script from "./Languagedropdown.vue?vue&type=script&lang=js&"
export * from "./Languagedropdown.vue?vue&type=script&lang=js&"
import style0 from "./Languagedropdown.vue?vue&type=style&index=0&id=d65803e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65803e2",
  null
  
)

export default component.exports